
import { ResizeHelper } from "../../dev/utils/ResizeHelper";
import { Helper } from "../../dev/utils/Helper";
import { StageLayer } from "@nolimitcity/slot-launcher/bin/StageLayer";
import { TextStyleOptions } from "../../dev/setting/text/IText";
import { FontWeight } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import { RoadRage } from '../RoadRage';
import { gsap,Power1, Power3, Power0 } from 'gsap';
import { SoundManager } from '../config/sound/SoundManager';
import { SoundConfig } from '../config/sound/SoundConfig';
import { SpinePlayer } from '../../dev/displayobject/SpinePlayer';
import { Sequence } from '../../dev/displayobject/Sequence';
import { MathHelper } from '../../dev/utils/MathHelper';
import { BLEND_MODES } from 'pixi.js';

export enum BGType { MAIN = "bgMaingame", FS3 = "bgFS1", FS4 = "bgFS2", FS5 = "bgFS3" };
export enum BGMoveDirection { LEFT, RIGHT, UP, DOWN };

export class Background extends PIXI.Container implements StageLayer {

    private DEFAULT_TEXT_STYLE: TextStyleOptions = {
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 10,
        dropShadowDistance: 6,
        fontFamily: "Helvetica",
        fontWeight: FontWeight.BOLD,
        fontSize: 90,
        align: "left",
        fill: [
            "white",
            "yellow",
            "red"
        ]
    };

    protected static _instance: Background;


    // private spLogo: PIXI.Sprite;

    protected _bgSprite: PIXI.TilingSprite;
    protected _bgSpriteSwitch: PIXI.Sprite;

    protected _moveTL: gsap.core.Timeline;
    protected _timeline: gsap.core.Timeline;

    protected _currentBGType: BGType = BGType.MAIN;

    protected needsToReset: boolean = false;

    private bgAnim: SpinePlayer;

    private bg_WIDTH: number = 1680;
    private bg_HEIGHT: number = 1680;


    private Cloud: Sequence;
    private Cloud_Rev: Sequence;

    private switchingTL:gsap.core.Timeline;

    public static get instance(): Background {
        return this._instance;
    }

    private set currentBgType(val:BGType){
        this._currentBGType = val;
        Helper.setTimeline().to([this.Cloud_Rev,this.Cloud],{alpha:0,duration:1}).add(() => {
            this.Cloud.tint = val === BGType.MAIN ? 0xFFFFFF : 0x555555;
            this.Cloud_Rev.tint = val === BGType.MAIN ? 0xFFFFFF : 0x555555;
         }).to([this.Cloud_Rev,this.Cloud],{ alpha:1, duration:5})
    }

    public get wantsToReset() {
        return this.needsToReset;
    }

    constructor() {
        super();
        Background._instance = this;
        this.init();
    }

    resetRequest(): void {
        this.needsToReset = this._currentBGType === BGType.FS3;
    }

    protected init(): void {

        this._bgSprite = this.addChild(new PIXI.TilingSprite(RoadRage.assetLoader.getTextures(this._currentBGType)[0], this.bg_WIDTH * 3, this.bg_HEIGHT));
        this._bgSprite.anchor.set(0.5, 0.5);

        this._bgSpriteSwitch = this.addChild(new PIXI.Sprite(RoadRage.assetLoader.getTextures(this._currentBGType)[0]));
        this._bgSpriteSwitch.anchor.set(0.5, 0.5);
        this._bgSpriteSwitch.alpha = 0;

        this.Cloud = this.addChild(new Sequence({ texturePath: "Beauty/clouds" }))
        this.Cloud.anchor.set(0.5, 0.5);

        this.Cloud.play({ repeat: -1 });
        this.Cloud.timeline?.fromTo(this.Cloud, { rotation: 0 }, { rotation: MathHelper.normalizedRotation(1), duration: 600, ease: Power0.easeNone });
        this.Cloud.scale.set(2);
        this.Cloud.alpha = 0;

        this.Cloud_Rev = this.addChild(new Sequence({ texturePath: "Beauty/clouds" }))
        this.Cloud_Rev.anchor.set(0.5, 0.5);
        
        this.Cloud_Rev.play({ repeat: -1 });
        this.Cloud_Rev.timeline?.fromTo(this.Cloud_Rev, { rotation: 0 }, { rotation: MathHelper.normalizedRotation(-1), duration: 600, ease: Power0.easeNone });
        this.Cloud_Rev.scale.set(2);
        this.Cloud_Rev.scale.x = -2;
        this.Cloud_Rev.alpha = 0;

        this.switchingTL = Helper.setTimeline(this.switchingTL, new gsap.core.Timeline({yoyo:true,repeat:-1}))
        this.switchingTL.fromTo(this.Cloud.scale, {x:2,y:2}, {x:2.1,y:2.1,duration:60,ease:Power1.easeInOut},0)
        this.switchingTL.fromTo(this.Cloud_Rev.scale,{x:1.9,y:1.9}, {x:2.02,y:2.02,duration:60,ease:Power1.easeInOut},0)

        this.bgAnim = this.addChild(new SpinePlayer("BG"))

        this.position.set(360, 360);
        this.onResize();
    }

    public forceBackground(gameSize: number): void {
        const nextBgType = [BGType.FS3, BGType.FS4, BGType.FS5][gameSize - 3];
        this.currentBgType = nextBgType;
        this._bgSprite.texture = this._bgSpriteSwitch.texture = RoadRage.assetLoader.getTextures(nextBgType)[0];
        this._bgSpriteSwitch.alpha = 0;
    }

    public attentionStart(respin: boolean = false): gsap.core.Timeline {
        this._bgSpriteSwitch.texture = RoadRage.assetLoader.getTextures(BGType.FS3)[0];
        this._timeline = Helper.setTimeline(this._timeline, new gsap.core.Timeline());
        this._timeline.fromTo(this._bgSpriteSwitch, { alpha: 0.77 }, { alpha: 0, duration: respin ? 0.6 : 1, ease: Power3.easeIn }, 0)
        return this._timeline;
    }

    public playNormalSwitch(toMain: boolean = false, durr: number, intro: boolean = false): gsap.core.Timeline {
        if (intro) this._bgSprite.texture = RoadRage.assetLoader.getTextures(BGType.FS3)[0];
        this.currentBgType = toMain ? BGType.MAIN : BGType.FS3;
        this._bgSpriteSwitch.texture = RoadRage.assetLoader.getTextures(this._currentBGType)[0];
        this._bgSpriteSwitch.alpha = 0;

        this._timeline = Helper.setTimeline(this._timeline, new gsap.core.Timeline({
            onComplete: () => {
                this._bgSprite.texture = this._bgSpriteSwitch.texture;
                this._bgSprite.alpha = 1;
            }
        }));
        this._timeline.fromTo(this._bgSprite, { alpha: 1 }, { alpha: 0, duration: durr, ease: Power3.easeInOut }, 0)
        this._timeline.fromTo(this._bgSpriteSwitch, { alpha: 0 }, { alpha: 1, duration: durr, ease: Power3.easeInOut }, 0)
        this.needsToReset = false;
        return this._timeline;
    }

    public fadeInCloud(): void {
        Helper.setTimeline().to([this.Cloud,this.Cloud_Rev], { alpha: 1, duration: 5 });
    }

    public speedUpCloud(): void {

        speed(this.Cloud,6);
        speed(this.Cloud_Rev,6);

        function speed(c:Sequence,speed:number){
            Helper.setTimeline().to([c],{alpha:0,duration:1}).add(() => {
                c.tint =  0x555555; }).to([c],{ alpha:1, duration:1})
            Helper.setTimeline().to([c.timeline!],{timeScale:speed,duration:3});
        }
    }

    public slowDownCloud(): void {

        slow(this.Cloud,1);
        slow(this.Cloud_Rev,1);
        
        function slow(c:Sequence,speed:number){
            Helper.setTimeline().to([c],{alpha:0,duration:1}).add(() => {
                c.tint =  0xFFFFFF; }).to([c],{ alpha:1, duration:1})
            Helper.setTimeline().to([c.timeline!],{timeScale:speed,duration:3});
        }
    }

    public setNewBackground(gameSize: number, durr: number, fromLeft: boolean): void {
        const nextBgType = [BGType.MAIN, BGType.FS4, BGType.FS5][gameSize - 3];
        if (nextBgType === this._currentBGType) return;

        this.currentBgType = nextBgType;
        this._bgSpriteSwitch.texture = RoadRage.assetLoader.getTextures(nextBgType)[0];
        this._bgSpriteSwitch.alpha = 0;

        this.playSwitchBackground(fromLeft, durr);
    }

    public playSwitchBackground(toLeft: boolean, durr: number = 0.72): gsap.core.Timeline {
        this._timeline = Helper.setTimeline(this._timeline, new gsap.core.Timeline({
            onStart: () => {
                this._bgSpriteSwitch.alpha = 1;
                this.bgAnim.scale.x = (toLeft ? 1 : -1);
                this.bgAnim.play({ animation: "BG_FS_Transition" })
            },
            onComplete: () => {
                this._bgSprite.texture = this._bgSpriteSwitch.texture;
                this._bgSpriteSwitch.alpha = 0;
                this._bgSprite.position.x = 0;
                this._bgSprite.position.x = 0;
            }
        }));

        this._bgSprite.x = 0;
        this._bgSpriteSwitch.x = (toLeft ? -this.bg_WIDTH : this.bg_WIDTH);

        this._timeline.to([this._bgSpriteSwitch, this._bgSprite], { x: (toLeft ? "+=" : "-=") + this.bg_WIDTH, duration: durr })

        RoadRage.overlayAnim.playMapSwitch();
        this._timeline.to(this, { alpha: 0.65, duration: durr / 2 }, 0)
        this._timeline.to(this, { alpha: 1, duration: durr / 2 }, durr / 2)
        // this._timeline.to([this._bgSprite], { x: (toLeft ? "+=" : "-=") + this.bg_WIDTH*2, duration: durr })

        return this._timeline;
    }

    onResize(): void {

        // this.spLogo.visible = !ResizeHelper.isIPadd;

        // if (ResizeHelper.isLandscape) {
        //     this.spLogo.scale.set(0.6);
        //     this.spLogo.position.set(-480, -200);
        // } else {
        //     this.spLogo.scale.set(0.8);
        //     this.spLogo.position.set(0, -480);
        // }
    }
}